import { use, useState } from "react";
import { Avatar, AvatarFallback, AvatarImage, personInitials } from "../ui/avatar";
import { MentionPeopleContext } from "./UserMention";

export function CommentAvatar({
  email,
  src,
  actorId,
}: {
  email: string | null;
  src?: string | null;
  actorId?: string | null;
}) {
  const people = use(MentionPeopleContext);
  const person = people.find((candidate) =>
    actorId
      ? candidate.userId === actorId
      : Boolean(email && candidate.email.toLowerCase() === email.toLowerCase()),
  );
  const photo = person ? person.avatarUrl : src;
  const label = person?.name || person?.email || email || "Comment author";
  const [broken, setBroken] = useState<string | null>(null);
  return (
    <Avatar className="size-8">
      {photo && photo !== broken ? (
        <AvatarImage src={photo} alt={`${label} avatar`} onError={() => setBroken(photo)} />
      ) : (
        <AvatarFallback className="text-[11px] text-muted-foreground">
          {personInitials({ name: person?.name ?? null, email })}
        </AvatarFallback>
      )}
    </Avatar>
  );
}
